import React, { Suspense, ComponentType, ReactNode } from 'react';

interface LazyComponentProps {
  fallback?: ReactNode;
}

/**
 * Creates a lazy-loaded component with a standardized Suspense wrapper
 * @param factory - Factory function that imports the component
 * @param fallback - Optional custom fallback element (defaults to Loading...)
 */
export function createLazyComponent<P extends Record<string, any>>(
  factory: () => Promise<{ default: ComponentType<P> }>,
  defaultFallback: ReactNode = <div>Loading...</div>
) {
  const LazyComponent = React.lazy(factory);

  return function LazyLoadedComponent(props: P & LazyComponentProps) {
    const { fallback = defaultFallback, ...componentProps } = props;
    return (
      <Suspense fallback={fallback}>
        <LazyComponent {...componentProps as any} />
      </Suspense>
    );
  };
}
